export const NewsTableHeaders = [
  "news-title",
  "news-description",
  "news-last-modified-by",
  "language",
  "modify",
];
